module.exports = __webpack_public_path__ + "img/reglette-double.909cbdf9.jpg";